import "../../pages/reports/gce-o.css";
import { ExamType } from "../../types/types";

interface SubjectData {
  code: string;
  name: string;
  student_count: string | number;
}

interface TTSubjectsTableProps {
  registrationData: {
    exam_registration?: {
      subject_categories?: Record<string, SubjectData[]>;
    } | null;
  } | null;
  selectedExamTypes: ExamType[];
}

const TTSubjectsTable: React.FC<TTSubjectsTableProps> = ({
  registrationData,
  selectedExamTypes,
}) => {
  const shouldRenderTables = selectedExamTypes.some((et) => {
    return et.name === "TT";
  }); // Use .some() instead of finding the exact one and checking

  if (!shouldRenderTables) return null;
  return (
    <table className="gceo-subjects-table">
      <tbody>
        <tr>
          {/* <th>S/N</th> */}
          <th colSpan={3}>SUBJECT</th>
          <th># of Candidates</th>
        </tr>
        {/* Placeholder rows for TT subjects */}
        {registrationData?.exam_registration?.subject_categories?.TTC.map(
          (subject, index) => (
            <tr key={index}>
              {/* <td>{index + 1}</td> */}
              <td colSpan={3}>{`${subject.code} ${subject.name}`}</td>
              <td>{subject.student_count}</td>
            </tr>
          )
        )}
      </tbody>
    </table>
  );
};

export default TTSubjectsTable;
